import React from 'react';
import { Empty, Spin } from 'antd';
import { ChartBox } from '../../../../ResultPanel/component/ChartBox';
import RoseChartPlotly from '../../../../../common/Chart/RoseChartPlotly';
import styles from '../../Layout/AnalyticsLayout.module.scss';
import { IBestDataset } from '../../../../../../types/analytics';
import ErrorDisplay from '../../ErrorDisplay';

interface RosePlotChartProps {
  rosePlotData: any[];
  rosePlotSeries: any[];
  pointName: string;
  coordinates: { lng: string; lat: string };
  directionChartNo: number;
  unitX: string;
  downloadName: string;
  selectedDatasetInfo?: IBestDataset;
  isLoading?: boolean;
  error?: string;
  isOffline: boolean;
  emptyText?: string;
}

export const RosePlotChart = ({
  rosePlotData,
  rosePlotSeries,
  pointName,
  coordinates,
  directionChartNo,
  unitX,
  downloadName,
  selectedDatasetInfo,
  isLoading = false,
  error,
  isOffline,
  emptyText = 'No data available',
}: RosePlotChartProps) => {
  if (isOffline) {
    return <ErrorDisplay isOfflineDataset={isOffline} />;
  }

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <Spin size='large' />
      </div>
    );
  }

  if (rosePlotData.length === 0 || rosePlotSeries.length === 0) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <Empty description={emptyText} />
      </div>
    );
  }

  return (
    <div className={styles.chartPointWrapper}>
      <div className={styles.analyticsPointName}>
        {pointName}
        <span className={styles.analyticsCoords}>
          ({coordinates.lng}°E; {coordinates.lat}°N)
        </span>
      </div>

      <div className={styles.chartContainer}>
        <ChartBox
          key='Rose Plot'
          title='Rose Plot'
          height={500}
          plot={
            <RoseChartPlotly
              id='Analytics-RosePlot-Plot'
              series={rosePlotSeries}
              data={rosePlotData}
              angle={-360 / directionChartNo / 2 - 90}
              unitX={unitX}
              downloadName={downloadName}
            />
          }
          dataset={selectedDatasetInfo?.label || ''}
        />
      </div>
    </div>
  );
};

export type { RosePlotChartProps };
